import type { ReactNode } from "react";
import { BrowserRouter, Route,  Routes } from "react-router-dom";
import './App.css'; 
import Login from 'Auth/Login'; 
import Cmslayout from 'components/cmslayout/Cmslayout';
import Dashboard from 'cmspages/Dashboard';  
import NewProcurement from "cmspages/NewProcurement";
import Signup from "Auth/Signup";
import CreatePassword from "Auth/CreatePassword";
import Product from "cmspages/Products";
import Markets, { MarketStoresPage } from "cmspages/Markets";
import StoreApproval from "cmspages/StoreApproval";
import ProductCategory from "cmspages/ProductCategory";
import MasterProducts from "cmspages/MasterProducts";
import Packages from "cmspages/Packages";
import ApprovedVendors from "cmspages/ApprovedVendors";
import AddRap from "cmspages/AddRap";
import {
  RepPerformancePage,
  RejectionsPage,
  ReviewsPage,
} from "cmspages/RepDashboard";
import AdminProtectedRoute from "shared/helpers/AdminProtectedRoute";

const withAdminProtection = (children: ReactNode) => (
  <AdminProtectedRoute>
    <Cmslayout className='appweblaout'>{children}</Cmslayout>
  </AdminProtectedRoute>
);

function App() {  
  return ( 
    <BrowserRouter>
      <Routes>  
          <Route path="/" element={<Login />} />   
          <Route path="/signup" element={<Signup />} />   
          <Route path="/update-password" element={<CreatePassword />} />   
          <Route path="/admin-panel" element={withAdminProtection(<Dashboard />)} />
          <Route path="/markets" element={withAdminProtection(<Markets />)} />
          <Route path="/admin/markets" element={withAdminProtection(<Markets />)} />
          <Route path="/markets/:marketId/stores" element={withAdminProtection(<MarketStoresPage />)} />
          <Route path="/admin/markets/:marketId/stores" element={withAdminProtection(<MarketStoresPage />)} />
          <Route path="/store-approval" element={withAdminProtection(<StoreApproval />)} />
          <Route path="/product-category" element={withAdminProtection(<ProductCategory />)} />
          <Route path="/admin/product-category" element={withAdminProtection(<ProductCategory />)} />
          <Route path="/master-products" element={withAdminProtection(<MasterProducts />)} />
          <Route path="/admin/master-products" element={withAdminProtection(<MasterProducts />)} />
          <Route path="/packages" element={withAdminProtection(<Packages />)} />
          <Route path="/admin/packages" element={withAdminProtection(<Packages />)} />
          <Route path="/approved-vendors" element={withAdminProtection(<ApprovedVendors />)} />
          <Route path="/add-rap" element={withAdminProtection(<AddRap />)} />
          <Route path="/admin/add-rap" element={withAdminProtection(<AddRap />)} />
          <Route path="/rep-performance" element={withAdminProtection(<RepPerformancePage />)} />
          <Route path="/rep-rejections" element={withAdminProtection(<RejectionsPage />)} />
          <Route path="/rep-reviews" element={withAdminProtection(<ReviewsPage />)} />
          <Route path="/products" element={withAdminProtection(<Product />)} />
          <Route
            path="/new-procurement"
            element={withAdminProtection(<NewProcurement />)}
          />
          
      </Routes>
  </BrowserRouter>
  );
}

export default App;
